import React, { lazy } from 'react'
import Loadable from 'app/components/Loadable/Loadable';

const TableListing = Loadable(lazy(() => import("../../components/TableListing/TableListing")));
const ItemDetails = Loadable(lazy(() => import("../../components/TableListing/ItemDetails")));
// const SBP = Loadable(lazy(() => import("../incentive/SBP")));
const ApplicationListing = Loadable(lazy(() => import("../../views/table-listing/ApplicationListing")));
const ImportSalesPerformances = Loadable(lazy(() => import("../../views/table-listing/ImportSalesPerformances")));
const SalesLeaderboard = Loadable(lazy(() => import("../../views/table-listing/SalesLeaderboard")));
const ImportTakafulIncentives = Loadable(lazy(() => import("../../views/table-listing/ImportTakafulIncentives")));
const TakafulLeaderboard = Loadable(lazy(() => import("../../views/table-listing/TakafulLeaderboard")));
const TakafulEsubmission = Loadable(lazy(() => import("../../views/table-listing/TakafulEsubmission")));
const TakafulNoSubmission = Loadable(lazy(() => import("../../views/table-listing/TakafulNoSubmission")));

const TableListingRoutes = [
    {
        path: '/listing/:detailsTitle',
        element: <TableListing />,
    },
    // {
    //     path: '/details/salary_base_points/:id',
    //     element: <SBP />,
    // },
    {
        path: '/details/:detailsTitle/:id',
        element: <ItemDetails />,
    },
    {
        path: '/customer/applications/:id',
        element: <ApplicationListing />,
    },
    {
        path: '/import/sales_performances',
        element: <ImportSalesPerformances />,
    },
    {
        path: '/sales/performance/leaderboard',
        element: <SalesLeaderboard />,
    },
    {
        path: '/import/takaful_incentives',
        element: <ImportTakafulIncentives />,
    },
    {
        path: '/takaful/leaderboard/:type',
        element: <TakafulLeaderboard />,
    },
    {
        path: '/takaful/esubmission',
        element: <TakafulEsubmission />,
    },
    {
        path: '/takaful/no_submission',
        element: <TakafulNoSubmission />,
    },
]

export default TableListingRoutes
